import { getHistoricLogs } from '@/features/AudienceManager/services';
export const fetchHistoricLogs = (payload) => getHistoricLogs(payload)
    .then(response => formatValue(response?.data))
    .catch(error => {
    console.error('Failed to fetch historic logs:', error);
    return formatValue(undefined);
});
const formatValue = (response) => {
    const historicLogs = response?.data ?? [];
    return {
        data: historicLogs.map(log => {
            return {
                status: log.status,
                connector: log.connector,
                audience: log.audience,
                duration: log.execTime,
                exportDate: log.exportDate,
                total: log.count || '-',
            };
        }),
        success: response?.success,
        totalCount: response?.totalCount ?? 0,
    };
};
